import React from 'react'

const RequestInformation = () => {
  return (
    <div>
      
    </div>
  )
}

export default RequestInformation
